<div class="dialog-content duo-action-dialog">
  <!--title 標題-->
  <h1 class="dialog-title">{{ 'modify-name-dialog.title' | translate }}</h1>
  <div mat-dialog-content>
    <div class="input-block">
      <label class="input-title input-text-required">{{
        'modify-name-dialog.name' | translate
      }}</label>
      <div class="input-group">
        <input
          matInput
          type="text"
          [(ngModel)]="name"
          appChineseEnglishSpaceOnly
          [placeholder]="'modify-name-dialog.name-placeholder' | translate"
          [maxlength]="nameMaxLength"
          [ngClass]="{ 'input-error': showError && name.trim() === '' }"
        />
        @if (showError && name.trim() === '' || validationErrors) {
          <mat-error class="input-error-msg"
            >{{
              'error.required'
                | translate
                  : { fieldName: 'modify-name-dialog.name' | translate }
            }}
          </mat-error>
        }
      </div>
    </div>
  </div>
  <div class="dialog-btn-block">
    <button
      mat-button
      class="btn-fill-primary btn-size-l"
      (click)="modifyName()"
    >
      {{ 'modify-name-dialog.modify-name' | translate }}
    </button>
    <button
      mat-button
      class="btn-text-underline btn-size-s"
      (click)="closeDialog()"
    >
      {{ 'common.button.cancel' | translate }}
    </button>
  </div>
</div>
